import { useAuth } from "@/contexts/AuthContext";
import { Notify } from "@/contexts/NotifyContext/Notify";
import { useNotify } from "@/contexts/NotifyContext";
import { useTheme } from "@/contexts/ThemeContext";
import logo from "@/assets/images/iasma.png";
import logo_white from "@/assets/images/iasma-white.png";
import { CredentialResponse, GoogleSignIn, GsiButtonConfiguration } from "@/contexts/AuthContext/GoogleSignIn";

export const LoginKind = {
  Regular: 0,
  GoogleSignin: 11,
};

export const LoginForm: React.FC = () => {
  const { signin } = useAuth();
  const { notify, setNotify } = useNotify();
  const { isDarkMode } = useTheme();

  const onGoogleSignIn = async (credentialResponse: CredentialResponse) => {
    setNotify(null); // Clear previous notifications
    try {
      console.log('Google Credential Response:', credentialResponse);
			let data = {
				kind: LoginKind.GoogleSignin,
				...credentialResponse,
			};
			await signin(data);
    } catch (error: any) {
      setNotify({ title: "Login Gagal", error, severity: 'error' });
    };
  };

  let gsiClientId: string = "197558973224-sojb48ffl4blvt98coufsdl5t2pgf75q.apps.googleusercontent.com"; // IASMA
  
  const buttonConfig: GsiButtonConfiguration = {
    type: "standard",
    theme: isDarkMode ? "filled_black" : "outline",
    size: "large",
    text: "signin_with",
    shape: "rectangular",
    logo_alignment: "left",
  };

  return (
    // <div className="min-h-screen bg-linear-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
    <div className="min-h-screen flex items-center justify-center bg-(--color-background) p-2 sm:p-4">
      
      <div className="bg-(--color-surface) border border-(--color-border) rounded-2xl shadow-lg p-6 sm:p-8 max-w-md w-full">
        <div className="flex justify-center mb-8 sm:mb-10">
          <img src={isDarkMode ? logo_white : logo} alt="IASMA Logo" className="w-15 h-15" />
          <div>
            <h1 className="text-3xl font-bold text-(--color-text)">IASMA</h1>
            <p className=" text-(--color-text-secondary)">SMA 1 Bukittinggi</p>
          </div>
        </div>

        <div className="flex justify-center">
          <GoogleSignIn buttonConfig={buttonConfig} callback={onGoogleSignIn} clientId={gsiClientId} />
        </div>

        <p className="text-xs text-(--color-text) text-center mt-6">
          Klik tombol di atas untuk login
        </p>
      </div>
      { notify && <Notify />}
    </div>
  );
};